export default __webpack_public_path__ + "static/media/cal_mob_dark.e1488101.png";